import React, {useState} from 'react';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import { Link } from 'react-router-dom';

import './Login.css';
import {Box, Button, Form, FormField, Heading, TextInput} from "grommet";

import {storeUserId, storeToken, storeRefreshToken} from '../utils/token'
import { ToastContainer, toast } from 'react-toastify';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    function handleSubmit(event) {
        event.preventDefault();

        axios.post(process.env.REACT_APP_BASE_API_URL + 'auth', {
            email,
            password,
        })
            .then(response => {
                storeToken(response.data.token);
                storeRefreshToken(response.data.refreshToken);
                let decodedToken = jwt_decode(response.data.token);
                storeUserId(jwt_decode(response.data.token).userId);
                window.location.href = '/webapp/dashboard';
            })
            .catch(error => {
                toast.error(error.response.data.message, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
    }

    return (
        <Box align="center" pad="medium">
            <Heading level={1}>Login</Heading>
            <Form onSubmit={handleSubmit}>
                <FormField name="email" label="Email">
                    <TextInput type="email" value={email} onChange={event => setEmail(event.target.value)} />
                </FormField>
                <FormField name="password" label="Password">
                    <TextInput type="password" value={password} onChange={event => setPassword(event.target.value)} />
                </FormField>
                <Box direction="row" justify="between" margin={{ top: 'medium' }}>
                    <Button type="submit" label="Login" primary />
                    <Link to="/forgot-password">
                        <Button label="Password dimenticata?" />
                    </Link>
                </Box>
            </Form>
            <Box margin={{ top: 'medium' }}>
                <span>Non hai ancora un account?</span>
                <Link to="/register">Registrati</Link>
            </Box>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Box>
    );
}

export default Login;